import React from "react"

import './DownloadMobile.css';


const DownloadMobile = ({link}) => {
    return (
        <div className={`download-mobile`}>
            <a className={`_cta-variation bold`}  href={link}>scaricare l'applicazione</a>
        </div>
    )
}

export default DownloadMobile